import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  explanationText: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
}))

export default useStyles
